import Breakpoint, { MAX, MIN } from '@maxpreps/shared/styles/breakpoint';
import { useIsScreenSize } from '../../hooks/useIsScreenSize';
import { IChildrenProps } from '../../models/utilTypes';

interface IScreenSizeProps extends IChildrenProps {
  minWidth?: number;
  maxWidth?: number;
}

export const ScreenSize: React.FC<IScreenSizeProps> = ({
  children,
  minWidth,
  maxWidth
}) => (useIsScreenSize(minWidth, maxWidth) ? (children as any) ?? null : null);

export const Desktop: React.FC<IChildrenProps> = ({ children }) => (
  <ScreenSize minWidth={Breakpoint.Desktop}>{children}</ScreenSize>
);

interface ITabletProps extends IChildrenProps {
  andBelow?: boolean;
  andAbove?: boolean;
}

export const Tablet: React.FC<ITabletProps> = ({
  children,
  andBelow = false,
  andAbove = false
}) => (
  <ScreenSize
    minWidth={andBelow ? MIN : Breakpoint.Tablet}
    maxWidth={andAbove ? MAX : Breakpoint.Desktop - 1}
  >
    {children}
  </ScreenSize>
);

export const Mobile: React.FC<IChildrenProps> = ({ children }) => (
  <ScreenSize maxWidth={Breakpoint.Tablet - 1}>{children}</ScreenSize>
);
